<!--The content below is only a placeholder and can be replaced.-->
<div style="text-align:center">
  <h1>{{ title }}</h1>
  <app-heroes></app-heroes>
</div>
